export * from './src/domain'
export * from './src/PaymentApiGatewayDefinition'

        import * as me from '@peachy/payments-pure'
        
        Object.entries(me).forEach(([exportedAs, exported]) => {
            if (exported && Object.isExtensible(exported)) {
                exported[Symbol.for('__WORKSPACE_HOME')] = '/Users/dan-parker/workspace/peachy-repo/comp-kit/payments/pure'
                exported[Symbol.for('__WORKSPACE_NAME')] = '@peachy/payments-pure'
                exported[Symbol.for('__EXPORTED_AS')] = exportedAs
            }
        })
    